import {
  PwdStrengthConditionType, UserAgeGroupType, UserCategoryType, UserGenderType, UserProfileType,
  UserPurposeType
} from '@/enums';
import {palette} from '@/styles';

export const PWD_STRENGTH_LIST = [
  {
    type: PwdStrengthConditionType.upperCase,
    label: '영대문자',
    regexp: new RegExp(/[A-Z]/g),
  },
  {
    type: PwdStrengthConditionType.lowerCase,
    label: '영소문자',
    regexp: new RegExp(/[a-z]/g),
  },
  {
    type: PwdStrengthConditionType.number,
    label: '숫자',
    regexp: new RegExp(/[0-9]/g),
  },
  {
    type: PwdStrengthConditionType.special,
    label: '기호',
    regexp: new RegExp(/([-/:;()₩&@".,?!'[\]{}#%^*+=_|~<>$£¥·])/g),
  },
];

export const PWD_STRENGTH_STATE = [
  '사용 불가',
  '보안 약함',
  '보안 보통',
  '보안 강함',
];

export const PWD_STRENGTH_STATE_COLOR = [
  palette.red400,
  palette.yellow500,
  palette.green500,
  palette.blue500,
];

export const USER_CATEGORIES = [
  {id: UserCategoryType.AuctionInvestor, label: '상가 경매 투자자'},
  {id: UserCategoryType.MultiStoreOwner, label: '다점포 점주'},
  {id: UserCategoryType.StartupCandidate, label: '예비 창업자'},
  {
    id: UserCategoryType.FranchiseHeadOffice,
    label: '프랜차이즈 본사 담당자',
  },
  {id: UserCategoryType.Other, label: '기타 (직접 입력)'},
];

export const USER_PURPOSE_OPTIONS = [
  {
    id: UserPurposeType.CustomerAnalysis,
    label: '고객 분석',
    hint: '유동 인구/배후세대 파악 등',
  },
  {
    id: UserPurposeType.SalesAnalysis,
    label: '매출 분석',
    hint: '매출 추세/지역별 매출 비교 등',
  },
  {
    id: UserPurposeType.FranchiseAnalysis,
    label: '업종 분석',
    hint: '인기/유망 업종 파악 등',
  },
  {
    id: UserPurposeType.CompetitorAnalysis,
    label: '경쟁사 분석',
    hint: '경쟁사 위치/매출 추정 등',
  },

  {id: UserPurposeType.Other, label: '기타', hint: '직접 입력'},
];

export const USER_EXTRA_INFO_STEPS = [
  {
    id: UserProfileType.gender,
    label: '성별을 알려주세요.',
    isMulti: false,
    options: [
      {id: UserGenderType.Male, label: '남성'},
      {id: UserGenderType.Female, label: '여성'},
      {id: UserGenderType.None, label: '비공개'},
    ],
  },
  {
    id: UserProfileType.ageGroup,
    label: '연령대를 알려주세요.',
    isMulti: false,
    options: [
      {id: UserAgeGroupType.Age20, label: '20대'},
      {id: UserAgeGroupType.Age30, label: '30대'},
      {id: UserAgeGroupType.Age40, label: '40대'},
      {id: UserAgeGroupType.Age50, label: '50대'},
      {id: UserAgeGroupType.Age60Over, label: '60대 이상'},
    ],
  },
  {
    id: UserProfileType.category,
    label: '나에게 해당하는 유형을 골라주세요.',
    isMulti: false,
    options: USER_CATEGORIES,
  },
];

export const DEVICE_ID_KEY = 'myfc/device-id';
